module.exports = __webpack_public_path__ + "img/cherries.b26dc820.svg";